// Costanti condivise della pipeline di produzione video.
export const FASI = [
  { key: 'script',         label: 'Script',         color: '#94a3b8' },
  { key: 'preproduzione',  label: 'Pre-produzione', color: 'var(--yellow)' },
  { key: 'riprese',        label: 'Riprese',        color: '#f97316' },
  { key: 'montaggio',      label: 'Montaggio',      color: 'var(--purple)' },
  { key: 'review_interna', label: 'Review interna', color: '#3b82f6' },
  { key: 'review_cliente', label: 'Review cliente', color: 'var(--cyan)' },
  { key: 'approvato',      label: 'Approvato',      color: 'var(--green)' },
];
export const FASE = Object.fromEntries(FASI.map(f => [f.key, f]));
export const FORMATI_VIDEO = ['Reel', 'Video YT'];

// secondi → "m:ss"
export function fmtTc(sec) {
  if (sec == null || isNaN(sec)) return '';
  const s = Math.max(0, Math.floor(Number(sec)));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}

export function fmtDurata(sec) {
  if (sec == null) return '';
  const s = Math.round(Number(sec));
  return s >= 60 ? `${Math.floor(s / 60)}m ${String(s % 60).padStart(2, '0')}s` : `${s}s`;
}

export function fmtSize(b) {
  if (!b) return '—';
  const u = ['B', 'KB', 'MB', 'GB'];
  let i = 0, n = Number(b);
  while (n >= 1024 && i < u.length - 1) { n /= 1024; i++; }
  return `${n.toFixed(n < 10 && i > 0 ? 1 : 0)} ${u[i]}`;
}

export function FaseBadge({ fase, style }) {
  const f = FASE[fase];
  if (!f) return null;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 11, fontWeight: 600, padding: '2px 8px',
      borderRadius: 7, whiteSpace: 'nowrap', color: f.color, background: 'var(--bg3)', border: '1px solid var(--border)', ...style }}>
      <span style={{ width: 6, height: 6, borderRadius: '50%', background: f.color }} />{f.label}
    </span>
  );
}
